<template>

    <div style="max-width: 400px;">

        <p v-if="path">{{ path }}</p>

        <input type="hidden"
               :name="inputName"
               v-if="path"
               v-model="path">

        <div>
            <a href="javascript:void(0)" class="btn btn-sm btn-primary" @click="showFileManager()">
                <span v-if="path === null">{{ t.__('Wybierz') }}</span>
                <span v-if="path !== null">{{ t.__('Zmień') }}</span>
            </a>
            <a href="javascript:void(0)" class="btn btn-sm btn-danger" v-if="path !== null" @click="clear()">{{ t.__('Usuń') }}</a>
        </div>

    </div>

</template>

<script>
export default {
    props: {
        inputName: {
            type: String,
            default: null
        },
        value: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            eventHub: window.eventHub,
            path: this.value
        }
    },
    model: {
        event: 'change'
    },
    methods: {
        showFileManager() {
            this.eventHub.$emit('show-file-manager', this._uid, 'path', null, this.path)
        },
        clear() {
            this.path = null;
            this.$emit('change', this.path);
        }
    },
    mounted() {
        if (CONFIG.oldInput.hasOwnProperty(this.inputName))  {
            this.path = CONFIG.oldInput[this.inputName];
            this.$emit('change', this.path);
        }
        this.eventHub.$on('file-manager-selected-' + this._uid, (path) => {
            this.path = path;
            this.eventHub.$emit('hide-file-manager')
            this.$emit('change', this.path);
        });
    }
};
</script>
